
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    columnView: { type: Boolean, default: false },
    hideTitle: { type: Boolean, default: false },
  },
  setup() {
    return {

    };
  },
});
